export const BadgeTypes = {
  default: "default",
  red: "red",
  yellow: "yellow",
  green: "green",
  blue: "blue",
  navy: "navy",
  purple: "purple",
  pink: "pink",
  black: "black",
  outline: "outline"
}

export const ButtonTypes = {
  default: "default",
  red: "red",
  yellow: "yellow",
  green: "green",
  blue: "blue",
  navy: "navy",
  purple: "purple",
  pink: "pink",
  black: "black",
  outline: "outline",
}

export const PublishTypes = {
  UNPUBLISHED: "UNPUBLISHED",
  PUBLISHED: "PUBLISHED"
}
